import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.ts';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@/assets/css/animation.css';

const app = createApp(App)
app.use(store)
app.mount('#app')


createApp(App).use(store).use(router).use(ElementPlus).mount('#app');
